import React from 'react';
import {
    List,
    Datagrid,
    TextField,
    DateField,
    Edit,
    SimpleForm,
    TextInput,
    required,
} from 'react-admin';
import { alpha, styled } from "@mui/material/styles";
import { Box, Typography, Paper } from '@mui/material';

const StyledSimpleForm = styled(SimpleForm)(({ theme }) => ({
    backgroundColor: '#fff',
    padding: '24px',
    borderRadius: '8px',
    boxShadow: '0px 2px 4px rgba(0, 0, 0, 0.05)',
    '& .MuiFormControl-root': {
        width: '100%',
        marginBottom: '16px'
    },
    '& .MuiInputBase-root': {
        width: '100%'
    }
}));

const AvailableCodesSection = () => (
    <Paper 
        elevation={2} 
        sx={{ 
            p: 3, 
            backgroundColor: '#f8f9fa',
            border: '1px solid #e9ecef',
            borderRadius: '8px',
            position: 'sticky',
            top: '0px',
            height: 'fit-content',
            minWidth: '400px',
            width: '400px'
        }}
    >
        <Typography variant="h6" sx={{ mb: 2, fontWeight: 600, color: '#495057' }}>
            Dostępne Kody
        </Typography>
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
                <Typography variant="body2" sx={{ 
                    fontFamily: 'monospace', 
                    backgroundColor: '#e9ecef', 
                    px: 1.5, 
                    py: 1, 
                    borderRadius: 1,
                    fontSize: '0.875rem',
                    fontWeight: 500,
                    textAlign: 'center'
                }}>
                    {'{{tender_name}}'}
                </Typography>
                <Typography variant="body2" sx={{ color: '#6c757d', fontSize: '0.875rem' }}>
                    Zostanie zastąpione rzeczywistą nazwą przetargu
                </Typography>
            </Box>
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
                <Typography variant="body2" sx={{ 
                    fontFamily: 'monospace', 
                    backgroundColor: '#e9ecef', 
                    px: 1.5, 
                    py: 1, 
                    borderRadius: 1,
                    fontSize: '0.875rem',
                    fontWeight: 500,
                    textAlign: 'center'
                }}>
                    {'{{bidder_name}}'}
                </Typography>
                <Typography variant="body2" sx={{ color: '#6c757d', fontSize: '0.875rem' }}>
                    Zostanie zastąpione rzeczywistą nazwą oferenta
                </Typography>
            </Box>
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
                <Typography variant="body2" sx={{ 
                    fontFamily: 'monospace', 
                    backgroundColor: '#e9ecef', 
                    px: 1.5, 
                    py: 1, 
                    borderRadius: 1,
                    fontSize: '0.875rem',
                    fontWeight: 500,
                    textAlign: 'center'
                }}>
                    {'{{bidder_public_uuid}}'}
                </Typography>
                <Typography variant="body2" sx={{ color: '#6c757d', fontSize: '0.875rem' }}>
                    Zostanie zastąpione publicznym UUID (public_id) oferenta
                </Typography>
            </Box>
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
                <Typography variant="body2" sx={{ 
                    fontFamily: 'monospace', 
                    backgroundColor: '#e9ecef', 
                    px: 1.5, 
                    py: 1, 
                    borderRadius: 1,
                    fontSize: '0.875rem',
                    fontWeight: 500,
                    textAlign: 'center'
                }}>
                    {'{{landing_page_url}}'}
                </Typography>
                <Typography variant="body2" sx={{ color: '#6c757d', fontSize: '0.875rem' }}>
                    Pełny link do strony zgody (np. https://portal/public/email/&lt;uuid&gt;)
                </Typography>
            </Box>
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
                <Typography variant="body2" sx={{ 
                    fontFamily: 'monospace', 
                    backgroundColor: '#e9ecef', 
                    px: 1.5, 
                    py: 1, 
                    borderRadius: 1,
                    fontSize: '0.875rem',
                    fontWeight: 500,
                    textAlign: 'center'
                }}>
                    {'{{unsubscribe_url}}'}
                </Typography>
                <Typography variant="body2" sx={{ color: '#6c757d', fontSize: '0.875rem' }}>
                    Pełny link do wypisania się z listy (np. https://portal/public/unsubscribe/&lt;uuid&gt;)
                </Typography>
            </Box>
        </Box>
    </Paper>
);

export const EmailTemplateList = () => (
    <List>
        <Datagrid rowClick="edit">
            <TextField source="name" />
            <TextField source="subject" />
            <DateField source="created_at" />
            <DateField source="updated_at" />
        </Datagrid>
    </List>
);

export const EmailTemplateEdit = () => (
    <Edit>
        <Box sx={{ display: 'flex', gap: 3, alignItems: 'flex-start' }}>
            <Box sx={{ flex: 1 }}>
                <StyledSimpleForm>
                    <TextInput source="name" validate={[required()]} />
                    <TextInput source="description" fullWidth multiline />
                    <TextInput 
                        source="subject" 
                        validate={[required()]} 
                        fullWidth 
                        helperText="You can use {{tender_name}}, {{bidder_name}}, {{bidder_public_uuid}} and {{landing_page_url}} codes for dynamic content"
                    />
                    <TextInput 
                        source="body" 
                        validate={[required()]} 
                        fullWidth 
                        multiline 
                        rows={15}
                        helperText="Enter HTML content for the email template. You can also use {{tender_name}}, {{bidder_name}}, {{bidder_public_uuid}} and {{landing_page_url}} codes here."
                    />
                </StyledSimpleForm>
            </Box>
            <AvailableCodesSection />
        </Box>
    </Edit>
); 